import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { TimepickerComponent } from './timepicker.component';
import { TimepickerConfig } from './timepicker.config';


export class TimepickerModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: TimepickerModule,
      providers: [TimepickerConfig]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CommonModule, FormsModule],
  declarations: [TimepickerComponent],
  exports: [TimepickerComponent, FormsModule]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
